import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAzure = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 14,
	viewBox: "0 0 16 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.26672 9.18648e-10H9.66339L5.09939 13.523C5.05248 13.662 4.96315 13.7828 4.84398 13.8683C4.72481 13.9539 4.58181 13.9999 4.43511 13.9999H1.0135C0.90236 13.9999 0.792818 13.9734 0.693934 13.9227C0.59505 13.872 0.509667 13.7984 0.44485 13.7082C0.380032 13.6179 0.337643 13.5135 0.32119 13.4036C0.304736 13.2936 0.314692 13.1814 0.350232 13.0761L4.60244 0.476891C4.64934 0.337893 4.73867 0.217111 4.85784 0.131558C4.97701 0.0460055 5.12002 -7.50699e-06 5.26672 9.18648e-10Z",
			fill: "url(#paint0_linear_530_3217)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.6557 9.07031H4.68367C4.61887 9.0703 4.55557 9.08979 4.502 9.12625C4.44843 9.16272 4.40708 9.21446 4.38332 9.27474C4.35956 9.33503 4.3545 9.40107 4.36879 9.46428C4.38308 9.52748 4.41607 9.58492 4.46345 9.62912L8.94356 13.8105C9.07396 13.9322 9.24569 13.9999 9.42407 13.9999H13.3717L11.6557 9.07031Z",
			fill: "#0078D4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.26674 4.83144e-06C5.11846 -0.000547778 4.97388 0.0463175 4.85412 0.133758C4.73436 0.221198 4.6457 0.344633 4.60106 0.48604L0.355525 13.0647C0.317607 13.1703 0.305702 13.2836 0.320817 13.3949C0.335932 13.5061 0.377622 13.6121 0.44236 13.7039C0.507098 13.7956 0.59298 13.8704 0.692741 13.9219C0.792502 13.9735 0.903206 14.0002 1.01549 13.9999H4.52543C4.6562 13.9765 4.77841 13.9189 4.87959 13.8328C4.98078 13.7468 5.05729 13.6354 5.10132 13.5101L5.94779 11.0151L8.97201 13.8357C9.09873 13.9405 9.2577 13.9985 9.42217 13.9999H13.3552L11.6302 9.07033L6.60153 9.07148L9.67941 4.83144e-06H5.26674Z",
			fill: "url(#paint1_linear_530_3217)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.882 0.476129C10.8352 0.337359 10.746 0.216776 10.627 0.131361C10.5081 0.0459461 10.3653 2.39684e-06 10.2188 0H5.31885C5.46532 -1.35151e-06 5.6081 0.0459398 5.72708 0.131354C5.84607 0.216769 5.93527 0.337354 5.98211 0.476129L10.2346 13.076C10.2701 13.1813 10.2801 13.2936 10.2636 13.4035C10.2472 13.5134 10.2048 13.6178 10.14 13.7081C10.0751 13.7984 9.98976 13.872 9.89087 13.9227C9.79199 13.9734 9.68245 13.9999 9.57131 13.9999H14.4713C14.5824 13.9999 14.692 13.9734 14.7908 13.9227C14.8897 13.8719 14.9751 13.7984 15.0399 13.7081C15.1047 13.6178 15.1471 13.5134 15.1635 13.4035C15.18 13.2936 15.17 13.1813 15.1345 13.076L10.882 0.476129Z",
			fill: "url(#paint2_linear_530_3217)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_530_3217",
				x1: 6.86922,
				y1: 1.03741,
				x2: 2.3032,
				y2: 14.5266,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#114A8B" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#0669BC"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_530_3217",
				x1: 8.2956,
				y1: 7.32368,
				x2: 7.23933,
				y2: 7.68081,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopOpacity: .3 }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .071,
						stopOpacity: .2
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .321,
						stopOpacity: .1
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .623,
						stopOpacity: .05
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopOpacity: 0
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_530_3217",
				x1: 7.71435,
				y1: .643898,
				x2: 12.7264,
				y2: 13.9972,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#3CCBF4" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#2892DF"
				})]
			})
		] })
	]
});
export default SvgAzure;
